const KB = 1024;
const MB = 1024 * KB;
const GB = 1024 * MB;
const TB = 1024 * GB;

/**
 * Format bytes as a human-friendly string (GB/MB/KB/B) in pt-BR.
 *
 * Examples:
 *   formatBytes(0)             -> "0 B"
 *   formatBytes(1500)          -> "1,46 KB"
 *   formatBytes(5368709120)    -> "5 GB"
 *   formatBytes(2_500_000_000) -> "2,33 GB"
 */
export function formatBytes(bytes: number): string {
  if (!bytes || bytes <= 0) return '0 B';

  const format = (value: number): string =>
    value.toLocaleString('pt-BR', {
      minimumFractionDigits: 0,
      maximumFractionDigits: 2,
    });

  if (bytes >= TB) return `${format(bytes / TB)} TB`;
  if (bytes >= GB) return `${format(bytes / GB)} GB`;
  if (bytes >= MB) return `${format(bytes / MB)} MB`;
  if (bytes >= KB) return `${format(bytes / KB)} KB`;
  return `${bytes} B`;
}

/**
 * Convert gigabytes to bytes (binary, 1 GB = 1024^3 bytes).
 */
export function gbToBytes(gb: number): number {
  return Math.round(gb * GB);
}

/**
 * Convert bytes to gigabytes. Keeps up to 2 decimals.
 */
export function bytesToGb(bytes: number): number {
  return Math.round((bytes / GB) * 100) / 100;
}
